
import { Badge, type BadgeProps } from "@chakra-ui/react"
import { Role } from "src/api/Role";
import { OrgUtil } from "src/data/OrgUtil";

interface RoleBadgeProps {
    role: Role
    size?: BadgeProps['size']
}

const RoleBadge = ({ role, size }: RoleBadgeProps) => {
    return (
        <>
            {OrgUtil.isRoleMember(role) && (<Badge size={size} variant='solid' colorPalette='green'>Mitglied</Badge>)}
            {OrgUtil.isRoleAdmin(role) && (<Badge size={size} variant='solid' colorPalette='orange'>Admin</Badge>)}
            {OrgUtil.isRoleRoot(role) && (<Badge size={size} variant='solid' colorPalette='red'>Entwickler</Badge>)}
            {OrgUtil.isRoleExtern(role) && (<Badge size={size} variant='solid' colorPalette='yellow'>Partner</Badge>)}
        </>
    )
}

export default RoleBadge
